import { WebSocketReceiveMessage } from './web-socket-receive-message';

export class WebSocketPong extends WebSocketReceiveMessage {}
